import {createStore, combineReducers, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducers/index';
import {user} from './reducers/user';
import {task} from './reducers/task';
import {tasklist} from './pages/task/tasklist/reducers';
import todayStartTask from './pages/task/todayStartTask/reducers';
import {login} from './pages/login/reduce';
import taskVolume from './pages/StatisticalAnalysis/taskVolume/reducers';
import {agencyAnalysis} from './pages/StatisticalAnalysis/agencyAnalysis/reducers';
import {agentConnentData} from './pages/StatisticalAnalysis/agentConnentData/reducers';
import {widthAndConnect} from './pages/StatisticalAnalysis/widthAndConnect/reducers';
import {taskStatistic} from './pages/StatisticalAnalysis/task-statistics/reducers';
import {advertPositionDataCurve} from './pages/StatisticalAnalysis/advertPositionDataCurve/reducers';
import {operaMonitor} from './pages/monitor/operating/reducers';
import {proxyExecuteData} from './pages/StatisticalAnalysis/proxyExecuteData/reducers';
import {messageList} from './pages/user/taskMessage/reducers';
import {hostList} from './pages/assist/hostManage/reducers';
import {userGroup} from './pages/user/userGroup/reducers';
import {statisticsView} from './pages/StatisticalAnalysis/statistics-view/reducers';
import {report} from './pages/StatisticalAnalysis/report/reducers';
import {index} from './pages/index/reducers';
import {everydayExecInfo} from './pages/StatisticalAnalysis/everydayExecInfo/reducers';
import clientList from './pages/client/clientList/reducers';
import commendList from './pages/client/commendList/reducers';
import scriptList from './pages/client/scriptList/reducers';
import advertPosition from './pages/client/advertPosition/reducers';
import advertPositionData from './pages/StatisticalAnalysis/advertPositionData/reducers';
import certificateList from './pages/client/certificateList/reducers';
import appList from './pages/client/AppList/reducers';
import appAccount from './pages/client/AppAccount/reducers';
import wxAccount from './pages/client/wxAccount/reducers';
import discardList from './pages/monitor/discard/reducers';
import agentManage from './pages/monitor/agent/reducers';
import taskExcuteData from './pages/monitor/taskExcuteData/reducers';
import localResourceRate from './pages/monitor/localResourceRate/reducers';
import taskIvt from './pages/monitor/taskIvt/reducers';
import fileList from './pages/fileList/reducers';
import signList from './pages/sign/signList/reducers';
import taskInfo from './pages/sign/taskInfo/reducers';
import thirdParty from './pages/monitor/thirdparty/reducers';
import clientManage from './pages/assist/clientManage/reducers';
import deviceIndex from './pages/assist/deviceIndex/reducers';
import logCollect from './pages/assist/logCollect/reducers';
import pie from './pages/monitor/name/reducers';
import taskNotes from './pages/sign/taskNotes/reducers';
import operationRecords from './pages/sign/operationRecords/reducers';
import machineCheck from './pages/client/machineCheck/reducers';
import {newExportData} from './pages/StatisticalAnalysis/newExportData/reducers';

let store = createStore(
    combineReducers({
        deviceIndex,
        logCollect,
        index,
        reducer,
        user,
        task,
        tasklist,
        taskStatistic,
        advertPositionDataCurve,
        agencyAnalysis,
        agentConnentData,
        widthAndConnect,
        login,
        operaMonitor,
        proxyExecuteData,
        messageList,
        userGroup,
        statisticsView,
        hostList,
        report,
        everydayExecInfo,
        clientList,
        commendList,
        scriptList,
        advertPosition,
        advertPositionData,
        certificateList,
        appList,
        discardList,
        agentManage,
        fileList,
        signList,
        taskInfo,
        thirdParty,
        clientManage,
        todayStartTask,
        pie,
        taskVolume,
        taskNotes,
        machineCheck,
        taskExcuteData,
        localResourceRate,
        taskIvt,
        operationRecords,
        newExportData,
        appAccount,
        wxAccount,
    }),
    applyMiddleware(thunk),
);

export default store;



// WEBPACK FOOTER //
// ./store.js